import { LOGO_URL } from "@/constants/brand";

export default function About() {
  return (
    <section id="about" className="py-24 md:py-36 bg-parchment-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Parish logo panel */}
          <div className="lg:col-span-5 relative order-2 lg:order-1">
            <div className="relative aspect-[4/5] bg-parchment-200 border border-parchment-400 grain overflow-hidden">
              {/* Inner ornament frame */}
              <div className="absolute inset-6 border border-parchment-400" />

              {/* Tau in the corners */}
              <div className="absolute top-3 left-3 text-terracotta text-2xl font-serif">✦</div>
              <div className="absolute top-3 right-3 text-terracotta text-2xl font-serif">✦</div>
              <div className="absolute bottom-3 left-3 text-terracotta text-2xl font-serif">✦</div>
              <div className="absolute bottom-3 right-3 text-terracotta text-2xl font-serif">✦</div>

              {/* Logo centerpiece */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-10 text-center">
                <img
                  src={LOGO_URL}
                  alt="Saint Francis of Assisi Parish — official seal"
                  className="w-2/3 max-w-[260px] drop-shadow-lg"
                />
                <div className="mt-8 font-serif italic text-2xl text-cocoa-900">
                  Pax et Bonum
                </div>
                <div className="text-[10px] uppercase tracking-[0.32em] text-sage-dark font-sans mt-2">
                  Peace and All Good
                </div>
              </div>
            </div>

            <div className="absolute -bottom-8 -right-4 lg:right-8 bg-parchment-50 border border-parchment-400 px-6 py-5 max-w-[240px] hidden md:block shadow-md">
              <div className="text-[10px] uppercase tracking-[0.28em] text-sage-dark font-sans mb-1">
                Patron Saint
              </div>
              <div className="font-serif italic text-cocoa-900 text-lg leading-snug">
                Francis of Assisi
              </div>
              <div className="text-cocoa-700 font-sans text-xs mt-1">1181 — 1226</div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-sage" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-sage-dark font-sans font-medium">
                About Our Parish
              </span>
            </div>
            <h2 className="font-serif text-[clamp(2rem,4vw,3.4rem)] leading-[1.1] text-cocoa-900">
              Rooted in Christ,
              <span className="block italic text-terracotta">walking with Saint Francis.</span>
            </h2>

            <div className="mt-8 space-y-5 font-sans text-cocoa-800 leading-relaxed font-light max-w-2xl">
              <p>
                Saint Francis of Assisi Parish is a community of prayer, formation, service,
                and mission. Inspired by the simplicity and fraternity of our patron,
                we seek to become a parish that listens, welcomes, serves, and walks
                with the people of God.
              </p>
              <p>
                Our parish life is nourished by the Eucharist, strengthened by the sacraments,
                and made concrete through the life of our GKKs, ministries, pastoral programs,
                and outreach to the poor and vulnerable.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg border-t border-parchment-400 pt-8">
              {[
                { n: "56", l: "GKK Communities" },
                { n: "10", l: "Active Ministries" },
                { n: "1", l: "Mission, Many Hands" },
              ].map((s) => (
                <div key={s.l}>
                  <div className="font-serif text-3xl text-terracotta">{s.n}</div>
                  <div className="text-[11px] uppercase tracking-[0.18em] text-cocoa-700 mt-1 font-sans">
                    {s.l}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
